import { request } from '../client'

import type { WeeklyLeaderboardResponse, SwitchTeamResponse, TeamStatusResponse } from '@/types/promotionalEvents'

export async function getWeeklyLeaderboard(eventId: string, date?: string) {
  return request<WeeklyLeaderboardResponse>({
    method: 'GET',
    url: `/v1/promotional-events/${eventId}/weekly-leaderboard`,
    params: date ? { date } : undefined,
  })
}

export async function getTeamStatus() {
  return request<TeamStatusResponse>({
    method: 'GET',
    url: '/v1/promotional-events/team-status',
  })
}

export async function switchTeam() {
  return request<SwitchTeamResponse>({
    method: 'POST',
    url: '/v1/promotional-events/switch-team',
  })
}
